import { navigate } from '@gatsbyjs/reach-router/';
import { globalizationPath } from '@rcg/ui-react';
import defaultNotifications from '../pages/index.defaults';
import { PAYMENT_ERROR, ROOT_PATH, NAVIGATION_PATHS, INTERNAL_SERVER_ERROR } from './constants';

export const handlePaymentError = (
  paymentErrorInfo,
  renderContent,
  setNotification,
  globalData,
) => {
  if (paymentErrorInfo) {
    const parseError = JSON.parse(JSON.stringify(paymentErrorInfo));
    const errorMessage =
      parseError.graphQLErrors && parseError.graphQLErrors[0]
        ? parseError.graphQLErrors[0].message
        : renderContent(
            'paymentNotificationTechnicalDificultiesDescription',
            'We are having issues right now. Try again later',
          );
    const errStatusCode =
      Array.isArray(parseError.graphQLErrors) &&
      parseError.graphQLErrors[0] &&
      parseError.graphQLErrors[0].code;
    const code =
      Array.isArray(parseError.graphQLErrors) &&
      parseError.graphQLErrors[0] &&
      parseError.graphQLErrors[0].extensions &&
      parseError.graphQLErrors[0].extensions.code;
    let errorDescription;
    let errorTitle;

    if (code === 'CSE5067') {
      errorTitle = renderContent('paymentNotificationDeclinedCreditCardTitle', 'Payment Error');
      errorDescription = renderContent(
        'paymentNotificationDeclinedCreditCardDescription',
        'Error occurred making payment: CREDIT CARD DECLINED',
      );
    } else if (code === 'CSE0098') {
      errorTitle = renderContent('paymentNotificationAccessBookingDeniedTitle', 'Payment Error');
      errorDescription = renderContent(
        'paymentNotificationAccessBookingDeniedDescription',
        'Error occurred getting current booking Error: Error occurred retrieving booking: Failed response in retrieving booking: ACCESS TO BOOKING ID DENIED. BOOKING IS LOCKED',
      );
    } else if (code === PAYMENT_ERROR) {
      if (
        parseError &&
        Array.isArray(parseError.graphQLErrors) &&
        parseError.graphQLErrors.find(({ extensions }) => extensions.code === PAYMENT_ERROR)
      ) {
        const cardsFound = [];
        let partialPayment = null;
        parseError.graphQLErrors.forEach(({ extensions }) => {
          if (extensions.successPayments) {
            partialPayment = {
              makePayment: extensions.successPayments,
              cardsAccepted: extensions.cardsAccepted,
            };
          }
          if (extensions.code === PAYMENT_ERROR) {
            extensions.errors.forEach((e) => {
              if (e.Card) {
                cardsFound.push(e.Card);
              }
            });
          }
        });
        if (partialPayment) {
          const { lang, market } = globalData;
          const urlPath = globalizationPath(market, lang, ROOT_PATH);
          navigate(`${urlPath}/${NAVIGATION_PATHS[0].dashboard}`, {
            state: { partialPayment },
          });
        } else if (cardsFound.length) {
          const amendErrorYourPaymentWithCardLabel = renderContent(
            'amendErrorYourPaymentWithCardLabel',
            'Your payment with card',
          );
          const amendErrorYourPaymentWithCardsLabel = renderContent(
            'amendErrorYourPaymentWithCardsLabel',
            'Your payment with cards',
          );
          const amendErrorWasDeclinedLabel = renderContent(
            'amendErrorWasDeclinedLabel',
            'was declined, try another card.',
          );
          const amendErrorWereDeclinedLabel = renderContent(
            'amendErrorWereDeclinedLabel',
            'were declined, try another card.',
          );
          errorDescription = `
              ${
                cardsFound.length === 1
                  ? amendErrorYourPaymentWithCardLabel
                  : amendErrorYourPaymentWithCardsLabel
              }
              ${' '}
              ${cardsFound.join(', ')}
              ${' '}
              ${cardsFound.length === 1 ? amendErrorWasDeclinedLabel : amendErrorWereDeclinedLabel}
            `;
          errorTitle = renderContent('amendPaymentFailedLabel', 'Payment failed');
          setNotification({
            description: errorDescription,
            open: true,
            title: errorTitle,
            type: 'error',
          });
        } else {
          errorTitle = renderContent('amendPaymentFailedLabel', 'Payment failed');
          errorDescription = renderContent(
            'amendThereWasAnErrorProcessingYourPaymentLabel',
            'There was an error while processing your payment. Please try again.',
          );
          setNotification({
            description: errorDescription,
            open: true,
            title: errorTitle,
            type: 'error',
          });
        }
      }
    } else if (code === INTERNAL_SERVER_ERROR) {
      errorDescription = renderContent(
        'paymentBookingAmendMessageError',
        'We are experiencing technical issues. Please try again later.',
      );
      errorTitle = renderContent('paymentBookingAmendErrorTitle', 'Technical Issues');
      setNotification({
        description: errorDescription,
        open: true,
        title: errorTitle,
        type: 'error',
      });
    } else {
      errorDescription =
        (errStatusCode &&
          defaultNotifications[errStatusCode] &&
          defaultNotifications[errStatusCode].description &&
          renderContent(
            defaultNotifications[errStatusCode].description.key,
            defaultNotifications[errStatusCode].description.defaultValue,
          )) ||
        errorMessage;
      errorTitle =
        (errStatusCode &&
          defaultNotifications[errStatusCode] &&
          defaultNotifications[errStatusCode].title &&
          renderContent(
            defaultNotifications[errStatusCode].title.key,
            defaultNotifications[errStatusCode].title.defaultValue,
          )) ||
        renderContent('paymentNotificationDefaultErrorTitle', 'Payment error');
    }

    setNotification({
      description: errorDescription,
      open: true,
      title: errorTitle,
      type: 'error',
    });
  }
};

export default handlePaymentError;
